module.exports = __webpack_public_path__ + "img/header.0080b836.gif";